<template>
    <DnSlider
        :items="items"
        :controls-enabled="controlsEnabled"
        :track-intersection="true"
        class="base-slider"
        :class="{
            'base-slider--compact': padding === 'compact'
        }"
        v-bind="$attrs"
    >
        <template
            v-for="name in Object.keys($slots)"
            v-slot:[name]="scope"
        >
            <slot
                :name="name"
                v-bind="scope || {}"
            />
        </template>

        <template v-slot:controlRight="{ scrollRight, isVisible }">
            <transition name="fade">
                <div
                    v-if="isVisible"
                    class="slider__control-right"
                >
                    <button
                        data-right
                        class="learning-paths__control"
                        type="button"
                        aria-label="Scroll right"
                        @click="scrollRight"
                    >
                        <BaseIcon icon="chevron-right" />
                    </button>
                </div>
            </transition>
        </template>

        <template v-slot:controlLeft="{ scrollLeft, isVisible }">
            <transition name="fade">
                <div
                    v-if="isVisible"
                    class="slider__control-left"
                >
                    <button
                        data-left
                        class="learning-paths__control"
                        type="button"
                        aria-label="Scroll left"
                        @click="scrollLeft"
                    >
                        <BaseIcon icon="chevron-left" />
                    </button>
                </div>
            </transition>
        </template>
    </DnSlider>
</template>

<script setup>
import DnSlider from '@digitalnatives/slider';

defineOptions({
    name: 'BaseSlider'
});

defineProps({
    items: {
        type: Array,
        required: true,
        default: () => []
    },
    controlsEnabled: {
        type: Boolean,
        default: false
    },
    padding: {
        type: String,
        default: 'default',
        validator: (value) => {
            return ['default', 'compact', 'spacious'].includes(value);
        }
    }
});
</script>

<style lang="less">
.base-slider {
    --slider-gap: 1rem;

    position: relative;
    min-height: 3.125rem;
    width: 100%;
    max-width: 100vw;

    display: flex;
    justify-content: center;

    .slider__item {
        white-space: normal;
    }
}

.slider__control {
    align-items: center;
    justify-content: center;

    position: absolute;
    top: 50%;
    width: 3.75rem;
    height: 3.75rem;
    font-size: 2.5rem;

    transform: translateY(-50%);

    border: 0;
    background: var(--color-darkest);
    color: var(--color-lightest);
    border-radius: var(--borderRadius-full);
    cursor: pointer;

    z-index: 10;

    &[data-left] {
        left: ~'max(2rem, calc(50% - var(--grid-maxWidth-page) / 2))';
    }

    &[data-right] {
        right: ~'max(2rem, calc(50% - var(--grid-maxWidth-page) / 2))';
    }
}

.slider__padding {
    scroll-snap-align: start;
    display: inline-block;
    flex: 0 0 auto;
    margin: 0;
}

.slider__padding:first-child,
.slider__padding:last-child {
    display: inline-block;
    scroll-snap-align: start;

    @media @q-lg-min {
        min-width: var(--grid-side-gap-md);
        width: calc(50% - var(--grid-maxWidth-page) / 2);
    }

    @media @q-xl-min {
        min-width: var(--grid-side-gap-lg);
        width: calc(50% - (1920px / 2) + var(--grid-side-gap-lg));
    }
}


.slider__control--disabled {
    opacity: 0;
}
</style>
